import React, { Fragment } from 'react';

import Icon from '~/core/scripts/components/Icon';

export default () => (
  <Fragment>
    <div className="chartbox__title">Die AfD in der bundesweiten Sonntagsfrage</div>
    <div className="chartbox__legend">
      <div className="chartbox__legend-item dots">
        <div className="icon"><div className="chartbox__legend-dot" /></div> Ein Punkt, eine Umfrage
      </div>
      <div className="chartbox__legend-item line">
        <Icon type="linechart" /> Mittelwert der Umfragen
      </div>
      <div className="chartbox__legend-item source">
        Quelle: <a href="http://www.wahlrecht.de/umfragen/index.htm" target="_blank">Wahlrecht.de</a>
      </div>
    </div>
  </Fragment>
);
